import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import { IOrderBump, IOrderBumpPagination } from "../types/OrderBump";
import OrderBumpController from "../controllers/OrderBumpController";
import { TProductTypePayment } from "../types/Product";

interface IProductOrderBumpsProp {
    typePayment?: TProductTypePayment;
}

export const useProductOrderBumps = ({ typePayment }: IProductOrderBumpsProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<IOrderBump[]>([]);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await OrderBumpController.getProducts({ typePayment });
                const responseError = response as IErrorResponse;
                if (responseError.code) {
                    setError(responseError.error);
                    setData([]);
                } else {
                    setData(response as IOrderBump[]);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, [typePayment]);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}